



export function sortByPriority<T>(dosings: (T & { priority: number })[])
{
  return dosings.sort((a, b) => a.priority - b.priority);
}